import { logger } from './logger.utils'
import type { MESSAGE_TYPE } from './sendMessage.const'

export function sendPostMessage(
  messageType: MESSAGE_TYPE,
  targetOrigin?: string | null,
  payload: Record<string, unknown> = {},
) {
  const message = {
    version: '1',
    messageType,
    data: {
      version: '001',
      content: payload,
    },
  }
  if (targetOrigin) {
    try {
      window.parent?.postMessage(JSON.stringify(message), targetOrigin)
    } catch (error) {
      // Do not crash the app if application is run on a different target origin than the one use by LCL
      logger.warn(error)
    }
  }
  return message
}
